/**
 * Display name for regulation attachment / doc_name filenames.
 * Strips a leading storage id prefix before the first underscore when it is:
 * - numeric (e.g. `1588936299_INS17340.pdf` → `INS17340.pdf`), or
 * - a UUID (e.g. `9006a447-2c70-4408-909b-5c838958e849_INS10427.pdf` → `INS10427.pdf`).
 * Leaves other names unchanged (e.g. `Guidance_v3.pdf`).
 */
const LEADING_STORAGE_ID_PREFIX =
  /^(?:(\d+)|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))_(.+)$/;

export function formatAttachmentDisplayName(fileName: string): string {
  const trimmed = (fileName ?? '').trim();
  if (!trimmed) {
    return '';
  }
  const match = LEADING_STORAGE_ID_PREFIX.exec(trimmed);
  return match?.[3] ?? trimmed;
}
